import { render } from "./ProjectSubSidebar.vue?vue&type=template&id=4572968a&scoped=true"
import script from "./ProjectSubSidebar.vue?vue&type=script&lang=js"
export * from "./ProjectSubSidebar.vue?vue&type=script&lang=js"

import "./ProjectSubSidebar.vue?vue&type=style&index=0&id=4572968a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4572968a"]])

export default __exports__